<template>
  <div>
    <!-- Modal -->
    <div id="modal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header d-flex align-items-center">
            <h2 class="text-center">Add new user</h2>
            <button type="button" class="close p-0 m-0" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <form @submit="submit" class="product-form">
              <div class="row">
                <div class="col-lg-12">
                  <label for="">
                    <span>Name:</span>
                    <input type="text" v-model="name" class="form-control">
                  </label>
                  <label for="">
                    <span>Username:</span>
                    <input type="text" v-model="username" class="form-control">
                  </label>
                  <label for="">
                    <span>Organization:</span>
                    <input type="text" v-model="organization" class="form-control">
                  </label>
                  <label for="">
                    <span>Account:</span>
                    <input type="text" v-model="account" class="form-control">
                  </label>
                  <label for="">
                    <span>Password:</span>
                    <input type="password" v-model="password" class="form-control">
                  </label>
                  <label for="">
                    <span>Role:</span>
                    <select v-model="role" class="form-control">
                      <option value="admin">Admin</option>
                      <option value="martinellis">Martinellis</option>
                      <option value="1868">1868</option>
                    </select>
                  </label>
                </div>
              </div>
              <div class="col-lg-12 d-flex justify-content-center mt-3">
                <button type="submit" :disabled="this.$store.getters.apiStatus == 'loading'" class="btn btn-success">
                  <div v-if="this.$store.getters.apiStatus != 'loading'">Save</div>
                  <div v-else class="loader"><Loader></Loader></div>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  name: 'UserModel',
  data () {
    return {
      username: '',
      password: '',
      name: '',
      organization: '',
      account: '',
      role: 'admin'
    }
  },
  methods: {
    submit (event) {
      event.preventDefault()
      let username = this.username
      let password = this.password
      let name = this.name
      let organization = this.organization
      let account = this.account
      let role = this.role
      this.$store.dispatch('createUser', { username, password, name, organization, account, role })
        .then(() => {
          this.$toast.success('New user created successfully')
          // eslint-disable-next-line no-undef
          $('#modal .close').click()
          this.username = ''
          this.password = ''
          this.$parent.fetchAllUsers()
        })
        .catch((err) => this.$toast.error(err.response.data.message))
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/UserModal.vue